

























































































































































































































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import Poles from '@/components/sites/Poles.vue';
import ReportFileTable from '@/components/ReportFileTable.vue';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';
import { DetailLayoutITF, LineValue } from '@/interfaces';

@Component({
  components: {
    Poles,
    ReportFileTable
  }
})
export default class SiteServiceOrderDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;

  public version = 1;
  public newSite = false;
  public initialSite: any = null;
  public initialReport: any = null;
  public differences = {};

  public claimOptionList = [
    {
      value: '',
      text: ''
    },
    {
      value: 'Averij',
      text: 'Averij'
    },
    {
      value: 'Maandstaat',
      text: 'Maandstaat'
    },
    {
      value: 'Structureel onderhoud',
      text: 'Structureel onderhoud'
    },
    {
      value: 'Vastlegging',
      text: 'Vastlegging'
    }
  ];

  public async getInitialLines(rec) {
    const siteId = rec.site_id;
    const reportId = rec.sitereport_id;
    // Get initial sitelines if list doesn't already exist
    if (siteId && !this.initialSite) {
      const siteResponse = await this.api.getRecord(
        this.$store,
        '/sites/' + siteId,
        {
          for_edit: 'yes'
        }
      );
      if (siteResponse) {
        this.initialSite = siteResponse.data;
      }
    }
    // Get initial reportlines if list doesn't already exist
    if (reportId && !this.initialReport) {
      const reportResponse = await this.api.getRecord(
        this.$store,
        '/sitereports/' + reportId,
        {
          for_edit: 'yes'
        }
      );
      if (reportResponse) {
        this.initialReport = reportResponse.data;
      }
    }
    // Calculate difference for site
    const fields = ['highway', 'trafficlight', 'installation_nr'];
    for (const f of fields) {
      this.differences[f] = rec[f] !== this.initialSite[f];
    }
    // Calculate difference for poles
    for (let i = 0; i < rec.poles.length; i++) {
      const initialPole = this.initialReport.poles[i];
      if (initialPole) {
        rec.poles[i].difference = {};
        rec.poles[i].difference.date_in =
          initialPole.date_in !== rec.poles[i].date_in;
        rec.poles[i].difference.date_out =
          initialPole.date_out !== rec.poles[i].date_out;
      }
    }
    // Calculate difference for sitelines
    for (const siteline of rec.sitelines) {
      const initialLine = this.initialSite.sitelines.find((l) => {
        return l.name === siteline.name;
      });
      if (initialLine) {
        siteline.difference = initialLine.value !== siteline.value;
      }
    }
    // Calculate difference for reportlines
    for (const reportline of rec.reportlines) {
      const initialLine = this.initialReport.reportlines.find((l) => {
        return l.name === reportline.name && l.site_nr === reportline.site_nr;
      });
      if (initialLine) {
        reportline.difference = initialLine.value !== reportline.value;
      }
    }
    // Update components
    this.version += 1;
  }

  public selectionChanged() {
    // Reset everything
    const ref: any = this.$refs.layout;
    ref.rec = { id: 0, ...this.getTableCfg(this.tableCfg, 'newRecord') };
    this.version += 1;
    ref.theForm.resetValidation();
  }

  public formatLine(line, siteNr): LineValue {
    return {
      id: 0,
      siteinfoline_id: line.id,
      value: line.default,
      value_index: line.default_index,
      linedatatype: line.linedatatype,
      name: line.name,
      title_nl: line.title_nl,
      title_fr: line.title_fr,
      values_fr: line.values_fr,
      values_nl: line.values_nl,
      site: line.site,
      site_nr: siteNr
    };
  }

  public getGeneralLines(lines) {
    return lines
      ? lines.filter(
          (site) => !site.name.includes('_1') && !site.name.includes('_2')
        )
      : [];
  }

  public getEntryLines(lines) {
    return lines ? lines.filter((site) => site.name.includes('_1')) : [];
  }

  public getExitLines(lines) {
    return lines ? lines.filter((site) => site.name.includes('_2')) : [];
  }

  public async getSite() {
    const ref: any = this.$refs.layout;
    const siteId = ref.rec.site_id;
    if (siteId) {
      const response = await this.api.getRecord(
        this.$store,
        '/sites/' + siteId,
        {
          for_edit: 'yes'
        }
      );
      if (response) {
        const site: any = response.data;
        ref.rec = JSON.parse(JSON.stringify({ ...ref.rec, ...response.data }));
        // Reset id to 0
        const lines: any = [];
        for (const line of ref.rec.sitelines) {
          line.id = 0;
          lines.push(line);
        }
        ref.rec.sitelines = lines;
        ref.rec.id = 0;
        ref.rec.site_id = Number(siteId);
        ref.rec.site = {};
        ref.rec.site.start_site_count = site.start_site_count;
        ref.rec.site.end_site_count = site.end_site_count;
        ref.rec.pole_count = site.site_count;
        ref.rec.siteinfo_id = site.sitetype.siteinfo_id;
        this.version += 1;
        this.getMostRecentReport(ref.rec, siteId);
      }
    } else {
      this.selectionChanged();
    }
  }

  public async getMostRecentReport(rec, siteId) {
    const response: any = await this.api.getTableData(
      this.$store,
      '/sitereports/',
      {
        site_id: siteId,
        most_recent: true
      }
    );
    if (response) {
      const mostRecentReports = response.data;
      if (mostRecentReports.data.length > 0) {
        // Most recent report exists
        const reportId = mostRecentReports.data[0].id;
        const reportResponse: any = await this.api.getRecord(
          this.$store,
          '/sitereports/' + reportId,
          {
            for_edit: 'yes'
          }
        );
        if (reportResponse) {
          const report = reportResponse.data;
          rec.sitereport_id = reportId;
          const reportlines: any[] = [];
          for (const line of report.reportlines) {
            if (line.site) {
              line.id = 0;
              reportlines.push(line);
            }
          }
          rec.remarks = report.remarks;
          rec.reportlines = reportlines;
          rec.poles = report.poles;
          rec.pole_count = rec.poles.length;
          this.version += 1;
        }
      } else {
        // No reports yet
        this.getReportLines(rec, rec.sitetype.siteinfo_id);
      }
    }
  }

  public async getReportLines(rec, siteInfoId) {
    if (siteInfoId) {
      const SiteInfoLinesResponse: any = await this.api.getLines(
        this.$store,
        '/siteinfos/' + siteInfoId
      );
      if (SiteInfoLinesResponse) {
        const lines: LineValue[] = [];
        for (const line of SiteInfoLinesResponse.data.data) {
          if (line.site) {
            for (let i = 1; i <= rec.site_count; i++) {
              const l = this.formatLine(line, i);
              lines.push(l);
            }
          }
        }
        rec.reportlines = lines;
        rec.poles = new Array(Number(rec.site_count)).fill({
          date_in: null,
          date_out: null
        });
        // Remove list observer
        rec.poles = JSON.parse(JSON.stringify(rec.poles));
      }
    } else {
      rec.reportlines = [];
      rec.poles = [];
    }
    this.version += 1;
  }

  public async initReportDetails(rec) {
    if (rec.sitetype_id && rec.site_count) {
      rec.pole_count = rec.site_count;
      const siteTypeResponse = await this.api.getRecord(
        this.$store,
        '/sitetypes/' + rec.sitetype_id
      );
      if (siteTypeResponse) {
        const siteType: any = siteTypeResponse.data;
        this.getReportLines(rec, siteType.siteinfo_id);
      }
    }
  }

  // Get lines of the selected site type
  public async getSiteTypeLines() {
    const ref: any = this.$refs.layout;
    const id = ref.rec.sitetype_id;
    if (id) {
      const response = await this.api.getLines(this.$store, '/sitetypes/' + id);
      if (response) {
        const lines: LineValue[] = [];
        for (const line of response.data.data) {
          const l: LineValue = {
            id: 0,
            sitetypeline_id: line.id,
            value: line.default,
            value_index: line.default_index,
            linedatatype: line.linedatatype,
            name: line.name,
            title_nl: line.title_nl,
            title_fr: line.title_fr,
            values_fr: line.values_fr,
            values_nl: line.values_nl
          };
          lines.push(l);
        }
        ref.rec.sitelines = lines;
        // Let detail layout component know that something changed
        ref.$refs.form.$emit('input');
      }
      if (this.newSite) {
        this.initReportDetails(ref.rec);
      }
    } else {
      ref.rec.sitelines = [];
    }
  }

  public async sendEmail(id) {
    const response = await this.api.postAction(
      this.$store,
      this.getTableCfg(this.tableCfg, 'apiUrl') + String(id) + '/sendmail'
    );
    if (response) {
      const ref: any = this.$refs.layout;
      (ref as DetailLayoutITF).getRecord();
    }
  }

  public async processServiceOrder(id) {
    const response = await this.api.postAction(
      this.$store,
      this.getTableCfg(this.tableCfg, 'apiUrl') + String(id) + '/process'
    );
    if (response) {
      const ref: any = this.$refs.layout;
      (ref as DetailLayoutITF).getRecord();
    }
  }

  public customSave(rec, apiUrl) {
    this.saveWithFiles(apiUrl);
    // Recalculate differences
    this.getInitialLines(rec);
  }

  public mounted() {
    this.getSite();
  }
}
